/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import {
  ActionType,
  ComponentType,
  EventName,
  FeatureUsageEventV2,
} from "@microsoftit/telemetry-extensions-npm";

import { config } from "../config";
import { getURLParams } from "../../components/util";
import { heartTelemetryLogger } from "./telemetry";

export const logHeartFeatureEvent = (
  featureName: string,
  subfeatureName: string,
  actionType: ActionType,
  actionName: string,
  eventName: EventName,  
  properties?: any
): void => {
  const telemetry = new FeatureUsageEventV2(
    featureName,
    actionType,
    actionName,
    eventName,
    ComponentType.Web,    
  );
  if (subfeatureName !== "") {
    telemetry.SubFeatureName = subfeatureName;
  }
  if (heartTelemetryLogger.candidateId === config.telemetry.defaultCandidateId) {
    const candidateId = getURLParams().candidateId;
    heartTelemetryLogger.candidateId = candidateId;
    heartTelemetryLogger.appInsights.appInsights.setAuthenticatedUserContext(candidateId);
  }
  telemetry.StartDateTime = new Date();
  heartTelemetryLogger.appInsights.TrackFeatureUsageEventV2(telemetry, properties);
};
